import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../provider/AuthProvider"; // Use your context
import { Box, CircularProgress } from "@mui/material";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useUser();
  console.log(user);
  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  if (!user) return <Navigate to="/login" replace />;

  return children;
};

export default PrivateRoute;
